module.exports = __webpack_public_path__ + "img/avatar-farmacia.png";